import { render, staticRenderFns } from "./ExamenPediatria.vue?vue&type=template&id=30b5acd0"
import script from "./ExamenPediatria.vue?vue&type=script&lang=js"
export * from "./ExamenPediatria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports